import { connect, ConnectedProps } from 'react-redux';
import { StateType } from '../../../../state/state.types';

const mapState = ({ results, queryParams }: StateType) => ({
  legislationSnippet: results.snippets.law,
  commentariesSnippet: results.snippets.commentaries,
  originalQueryKey: queryParams.originalQueryKey,
});

export const Connect = connect(mapState);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
